import type { SitecorePageFields } from '@/cms/fields/types/common';

import { createReactPageRegistry } from '@/cms/reactPageRegistry';
import { createReactHybridPageRegistry } from '@/cms/reactHybridPageRegistry';
import { AccommodationPageFullReact as AccommodationPage } from '@/scopes/products/pages';
import NewSearchPage from '@/scopes/search/search/pages/SearchPage/SearchPage';
import CheckoutPageStep1 from '../scopes/checkout/pages/Step1';
import WinterCheckoutPageStep1 from '../scopes/checkout/pages/WinterStep1';
import GroupsCheckoutStep1 from '@/scopes/checkout/pages/groups/Step1';
import GroupsCheckoutPersonalDetails from '@/scopes/checkout/pages/groups/PersonalDetailsStep';
import GroupsCheckoutOverviewStep from '@/scopes/checkout/pages/groups/OverviewStep';
import GroupsCheckoutConfirmationStep from '@/scopes/checkout/pages/groups/Confirmation';
import { GroupsResponsible } from '@/scopes/account/group-responsible/pages';
import featureFlagClient from '@/scopes/common/infrastructure/feature-flags/featureFlagClient';
import { isSummerPDP } from '@/cms/reactPageRegistryRules';
import { CANARY_RELEASE_PDP_ID, SEO_TEST_PDP_ID } from '@/constants';
import QuickSearch from '@/scopes/search/quick-search/components';
import templateName, { TemplateName } from '@/scopes/common/infrastructure/cms/templateName';

const reactHybridPageRegistry = createReactHybridPageRegistry();
reactHybridPageRegistry.register('HomePage');
reactHybridPageRegistry.register('BrandSummerHomePage');
reactHybridPageRegistry.register('ContentPage');

const reactPageRegistry = createReactPageRegistry();
// TODO Create new ReactAccomodation Page

const FF_ACTIVATE_FULL_REACT_PDP = featureFlagClient.isActive('ACTIVATE_FULL_REACT_PDP');

if (FF_ACTIVATE_FULL_REACT_PDP) {
  reactPageRegistry.registerByRule(isSummerPDP, AccommodationPage);
}

function isABTestFullReactBVariantSummerPDP(pageProps: {
  page: { id: string; template: string };
  fields: SitecorePageFields;
  isAbTestBVariant: boolean;
  enableAbTest: boolean;
}) {
  if (
    pageProps?.enableAbTest &&
    pageProps?.isAbTestBVariant &&
    templateName.matchesTemplate(TemplateName.PDP, pageProps?.page?.template)
  ) {
    return pageProps?.page?.id;
  }
  return false;
}

const FF_ACTIVATE_FULL_REACT_PDP_AB_TEST = featureFlagClient.isActive('ACTIVATE_FULL_REACT_PDP_AB_TEST');
if (FF_ACTIVATE_FULL_REACT_PDP_AB_TEST) {
  reactPageRegistry.registerByRule(isABTestFullReactBVariantSummerPDP, AccommodationPage);
}

function isCanaryReleasePDP(pageProps: {
  page: { id: string };
  fields: SitecorePageFields;
  isAbTestBVariant: boolean;
  enableAbTest: boolean;
}) {
  if (pageProps?.enableAbTest && pageProps?.isAbTestBVariant) {
    return CANARY_RELEASE_PDP_ID.some((id) => id === pageProps?.page?.id);
  }
  return false;
}

const FF_ACTIVATE_CANARY_RELEASE_FULL_REACT_PDP = featureFlagClient.isActive('ACTIVATE_CANARY_RELEASE_FULL_REACT_PDP');
if (FF_ACTIVATE_CANARY_RELEASE_FULL_REACT_PDP) {
  reactPageRegistry.registerByRule(isCanaryReleasePDP, AccommodationPage);
}

function isSEOTestPDP(pageProps: { page: { id: string }; fields: SitecorePageFields }) {
  return SEO_TEST_PDP_ID.some((id) => id === pageProps?.page?.id);
}

const FF_ACTIVATE_SEO_TEST_FULL_REACT_PDP = featureFlagClient.isActive('ACTIVATE_SEO_TEST_FULL_REACT_PDP');
if (FF_ACTIVATE_SEO_TEST_FULL_REACT_PDP) {
  reactPageRegistry.registerByRule(isSEOTestPDP, AccommodationPage);
}

reactPageRegistry.register('d4c58c1a-aadb-468f-84c1-358b21619a59', NewSearchPage);
reactPageRegistry.register('0e5d98d9-b851-4e8a-b20d-a64364e0354a', CheckoutPageStep1); // TEST
reactPageRegistry.register('5b4663a8-15dd-47a4-ac69-68b4bb20e8f7', CheckoutPageStep1); // ACPT
reactPageRegistry.register('023315ee-35ed-46a5-885b-4e83315b50e9', CheckoutPageStep1); // PROD
reactPageRegistry.register('600adc1c-0a1c-49e7-9743-9a0112ea5684', WinterCheckoutPageStep1); // ACPT
reactPageRegistry.register('f6958d56-6fb7-44c4-95de-29cfd9c265ac', WinterCheckoutPageStep1); // PROD
reactPageRegistry.register('eebea8a6-bf8d-46ce-b869-90f77c656fab', GroupsCheckoutStep1);
reactPageRegistry.register('903d0998-a38d-465e-bd03-18c28faa7f37', GroupsCheckoutPersonalDetails);
reactPageRegistry.register('35508b07-1720-4eea-9960-38bb1e63f3db', GroupsCheckoutOverviewStep);
reactPageRegistry.register('6e5596a2-3c23-49ad-849e-6acba1e010b4', GroupsCheckoutConfirmationStep);
reactPageRegistry.register('7f45b2c3-1234-56d7-89ab-cdef01234567', GroupsResponsible);
reactPageRegistry.register('7f45b2c3-1234-56d7-89ab-cdef01234999', QuickSearch);

export { reactPageRegistry, reactHybridPageRegistry };
